import Score from "./score";
import {isSeriesCompleted} from "./base";
import {winner_score} from "../utils";

class Game extends Score {

  type_game = 'big_round_5'

  constructor(store, default_game, urls = window.URLS) {
    super(store, default_game, urls, 'big_round_5')
  }

  getMaxSeriesBySettings(leg) {
    const {settings, data} = this.get('game')
    const init_max_series = settings.max_series || 5
    const i = data.indexOf(leg)
    return i >= 3 ? init_max_series + 1 : init_max_series
  }

  calculateTotalScore(legs = []) {
    return legs.reduce((scores, leg, i) => {
      const winner_number = this.getWinnerNumberByLeg(leg)
      if (winner_number === 1) scores[0] += 1
      if (winner_number === 2) scores[1] += 1
      if (!winner_number && this.isComplete(leg)) {
        scores[0] += 1
        scores[1] += 1
      }
      return scores
    }, [0, 0])
  }

  // isDraw() {
  //   return false
  // }

  isFinalDraw() {
    const {data, score_1, score_2} = this.get('game')
    if (data.length >= 4) {
      if (this.isComplete(data.at(-1))) {
        const [total_score_1, total_score_2] = this.totalScore()
        return !(winner_score(score_1, score_2) || winner_score(total_score_1, total_score_2))
      }
    }
  }

  preSave(body) {
    body = super.preSave(body)
    if (body.data.length >= 4) {
      if (this.isComplete(body.data.at(-1))) {
        if (winner_score(body.score_1, body.score_2)) {
          body.end_time = new Date().getTime()
        } else if(!body.winner_number) {
          const [total_score_1, total_score_2] = this.totalScore()
          const winner = winner_score(total_score_1, total_score_2)
          if (winner) {
            body.winner_number = winner
            body.end_time = new Date().getTime()
          }
        }
      }
    }
    return body;
  }

  offsetSectors(i) {
    const legs = this.get('game').data
    if (typeof i !== 'number') {
      i = legs.length
    }
    const slice_legs = legs.slice(0, i + 1)
    return slice_legs.length ? (slice_legs.length - 1) * 5 : 0
  }

  totalScore() {
    return this.get('game').data.reduce((acc, leg) => {
      const [score_leg_1, score_leg_2] = this.calculateScore(leg)
      return [acc[0] + score_leg_1, acc[1] + score_leg_2]
    }, [0, 0])
  }
}

export default Game